module.exports = __webpack_public_path__ + "static/img/touxiang2.568b30e7.png";